import {metadaApi} from '@dms/api/base';

import {
  HeaderDynamicActionsEventRequest,
  HeaderDynamicActionsEventRequestSchema,
  HeaderDynamicActionsEventResponse,
  HeaderDynamicActionsEventResponseSchema,
  HeaderDynamicActionsRequest,
  HeaderDynamicActionsRequestSchema,
  HeaderDynamicActionsResponse,
  HeaderDynamicActionsResponseSchema,
} from './types';

export const metadaWarehouseHeaderDynamicActionsApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getWarehouseHeaderDynamicActions: build.query<
      HeaderDynamicActionsResponse,
      HeaderDynamicActionsRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/${queryArg.resource}/${queryArg.id}/actions`,
        method: 'GET',
      }),
      providesTags: ['headerDynamicActions'],
      extraOptions: {
        requestSchema: HeaderDynamicActionsRequestSchema,
        responseSchema: HeaderDynamicActionsResponseSchema,
      },
    }),
    putWarehouseHeaderDynamicActions: build.mutation<
      HeaderDynamicActionsEventResponse,
      HeaderDynamicActionsEventRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/${queryArg.version ?? 'v1'}/${queryArg.resource}/${queryArg.id}/action`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: [
        'article',
        'deliveryNote',
        'receiveNote',
        'receiveNoteCorrections',
        'directSales',
        'serviceOrderIssueNotes',
        'serviceOrderReturns',
        'partsRequestReturnBasket',
        'headerDynamicActions',
        'supplierOrders',
        'articleUpdateJobs',
        'fastTrackIssues',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJob',
        'serviceOrderJobs',
        'serviceOrderJobTotalAmount',
        'pendingServiceOrderReturn',
        'transferOrders',
      ],
      extraOptions: {
        requestSchema: HeaderDynamicActionsEventRequestSchema,
        responseSchema: HeaderDynamicActionsEventResponseSchema,
      },
    }),
  }),
});

export const {
  useGetWarehouseHeaderDynamicActionsQuery,
  usePutWarehouseHeaderDynamicActionsMutation,
} = metadaWarehouseHeaderDynamicActionsApi;
